import React from 'react'
import axios from 'axios'
import { useEffect, useRef, useState, useImperativeHandle, forwardRef } from 'react'
import { useDialog } from '../DialogProvider'
import { useLang } from '../LangProvider'
import { useAuth } from '../AuthProvider'
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import moment from 'moment'

const Register = forwardRef(( props, ref ) => {

  useImperativeHandle(ref, () => ({
    openDialog() {
      handleClose()
      //console.log("register dialog opened from provider")
      handleOpenDialog()
    }
  }) )

  const [dialogState,setDialogState] = useState(false)

  const ava = useRef(null)

  const closeDialog = useDialog()
  const dialogRef = useRef(null)
  const {lang} = useLang()
  const [areas,setAreas] = useState({none:"Loadong ..."})
  const [cities,setCities] = useState({none:"Loadong ..."})
  const [wh, setWh] = useState({none:"Loadong ..."})
  const [registred, setRegistred] = useState(true)
  const [response,setResponse] = useState('none')
  const {auth, setAuth} = useAuth()

  //console.log('register dialog:',props)
  

  // validation patterns
  const pattern = {
    username: `.{3,}`,
    firstname:`.{2,}`,
    secondname:`.{2,}`,
    lastname:`.{3,}`,
    mail:`^(("[\w-\s]+")|([\w-]+(?:\.[\w-]+)*)|("[\w-\s]+")([\w-]+(?:\.[\w-]+)*))(@((?:[\w-]+\.)*\w[\w-]{0,66})\.([a-z]{2,6}(?:\.[a-z]{2})?)$)|(@\[?((25[0-5]\.|2[0-4][0-9]\.|1[0-9]{2}\.|[0-9]{1,2}\.))((25[0-5]|2[0-4][0-9]|1[0-9]{2}|[0-9]{1,2})\.){2}(25[0-5]|2[0-4][0-9]|1[0-9]{2}|[0-9]{1,2})\]?$)`,
    telephone:`[+]{0,1}[0-9 \\-]{10,}`,
    birthDate:``,
    country:`.{5,}`,
    city:`.{3,}`,
    club:`.{3,}`,
    emergencyContacts:`.{20,}`,
    password:`.{6,}`,
    repeatPassword:`.{6,}`,
  }

  // refs for login
  const usernameRef = useRef(null),
        passwordRef = useRef(null)

  // refs for registration
  const emailRef = useRef(null),
        countryRef = useRef(null),
        cityRef = useRef(null),
        firstNameRef = useRef(null),
        secondNameRef = useRef(null),
        lastNameRef = useRef(null),
        sosRef = useRef(null),
        genderRef = useRef(null),
        birthdateRef = useRef(null),
        npAreaRef = useRef(null),
        npCityRef = useRef(null),
        npWhRef = useRef(null),
        passwordRepeatRef = useRef(null),
        telephoneRef = useRef(null),
        shirtRef = useRef(null),
        clubRef = useRef(null),
        policiesRef = useRef(null)

  useEffect(() => {
    dialogRef.current.setAttribute("open", false);
    getAreas()
  },[])

  const getAreas = () => {
    axios
    .get(
      process.env.REACT_APP_BACKEND_REGIONS,{
        headers:{
          accept:"application/json",
          //authorization : `Bearer ${tokenStr}`
        }
      }
    )
    .then(res => {
      //console.log('areas',res.data)
      setAreas(res.data)
    })
    .catch((err) => {
      setAreas({'0':'Can`t get city list :('})
      console.log(err)
    })
  }

  const updateCities = (area) =>{
    //console.log("area",typeof area, area.nativeEvent.target.value)
    //console.log('npArea update',npAreaRef)
    if (!area ||  area.nativeEvent.target.value === 'none') return
    axios
    .get(process.env.REACT_APP_BACKEND_CITIES,{
      params:{
        "area": area.nativeEvent.target.value
      },
      headers:{
        accept:"application/json"
      }
    })
    .then(
      res=>{
        //console.log('cities :', res)
        setCities(res.data)
      }
    )
    .catch(() => {
      setCities(null)
      return <option defaultValue disabled> no cities found </option>
    })
  }

  const updateWahehouses = (city) =>{
    //console.log("city", city.nativeEvent.target.value)
    if (!city ||  city.nativeEvent.target.value === 'none') return
    axios
    .get(process.env.REACT_APP_BACKEND_WAREHOUSES, {
      params:{
        "city":city.nativeEvent.target.value},
      headers:{
        accept:"application/json"
      }
    })
    .then(
      res=>{
        //console.log('WH :', (res))
        setWh(res.data)
      }
    )
    .catch(() => {
      setWh(null)
      return <option defaultValue disabled> no warehouses found </option>
    })
  }
  
  function handleSubmit(){
    if (registred){
      logIn()
    }else{
      register()
    }

    /**validate vith valodator lib here ? 
     * method #3 https://mailtrap.io/blog/validate-emails-in-react/
    */
  }

  function logIn(){
    let username = usernameRef.current
    let password = passwordRef.current

    //console.log('log in validation:',username,password)

    if (!username.validity.valid &&
        !password.validity.valid){
          //console.log('clien-side invalid input')
          setResponse('log in error')
          return null;
        }

    let data = new FormData()
    data.append('username',username.value)
    data.append('password',password.value)

    //console.log("login data",data)

    axios({
      method: "post",
      url:process.env.REACT_APP_BACKEND_LOGIN,
      data: data,
      headers: {"Content-type":"multipart/form-data"}
    })
    .then(res => {
      //console.log('login response',res)
      if (res.data.hasErrors){
        setResponse('log in error')
      }else{
        let timestamp = Date.now()
        localStorage.setItem('token', res.data.token)
        localStorage.setItem('username', res.data.username)
        localStorage.setItem('timestamp', String(timestamp))
        setAuth({ token:res.data.token,
          username:res.data.username,
          timestamp: timestamp,
          isAuth:true})
        setResponse('logged in')
        handleClose()
        window.location.reload(false)
      }
    })
    .catch(err => {
      console.log('login error:',err)
      if (err.response.data.status === 403){
        // forbidden if email is on confirmed
        toast.warn(err.response.data.message,{
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: false,
          draggable: true,
          progress: undefined,
          theme: "colored",
          containerId:"dialog-register"
        })
      }else{
        setResponse('log in error')
      }
    })
  }

  function register(){
    let username          = usernameRef.current,
        email             = emailRef.current,
        country           = countryRef.current,
        city              = cityRef.current,
        firstName         = firstNameRef.current,
        secondName        = secondNameRef.current,
        lastName          = lastNameRef.current,
        sos               = sosRef.current,
        gender            = genderRef.current,
        birthDay          = birthdateRef.current,
        year              = moment(birthDay.value).format("YYYY"),
        month             = moment(birthDay.value).format("MM"),
        day               = moment(birthDay.value).format("DD"),
        npArea            = npAreaRef.current.options[npAreaRef.current.selectedIndex].text,
        npAreaRefVal      = npAreaRef.current.value,
        npCity            = npCityRef.current.options[npCityRef.current.selectedIndex].text,
        npCityRefVal      = npCityRef.current.value,
        npWarehouse       = npWhRef.current.options[npWhRef.current.selectedIndex].text,
        npWarehouseRefVal = npWhRef.current.value,
        password          = passwordRef.current,
        passwordRepeat    = passwordRepeatRef.current,
        telephone         = telephoneRef.current,
        shirt             = policiesRef.current,
        club              = clubRef.current,
        policies          = policiesRef.current

        // check validity, utilises build-in browser validation via input patterns
    if (!(username.validity.valid ||
          email.validity.valid ||
          telephone.validity.valid ||
          birthDay.validity.valid ||
          city.validity.valid ||
          sos.validity.valid ||
          password.validity.valid ||
          passwordRepeat.validity.valid ||
          policies.checked)){
            setResponse('registration error')
            return null;
    }

    let data = new FormData()
    data.append('username',username.value)
    data.append('email',email.value)
    data.append('country',country.value)
    data.append('city',city.value)
    data.append('firstName',firstName.value)
    data.append('secondName',secondName.value)
    data.append('lastName',lastName.value)
    data.append('sos',sos.value)
    data.append('gender',gender.value)
    data.append('year',year)
    data.append('month',month)
    data.append('day',day)
    data.append('npArea',npArea)
    data.append('npAreaRef',npAreaRefVal)
    data.append('npCity',npCity)
    data.append('npCityRef',npCityRefVal)
    data.append('npWarehouse',npWarehouse)
    data.append('npWarehouseRef',npWarehouseRefVal)
    data.append('password',password.value)
    data.append('passwordRepeat',passwordRepeat.value)
    data.append('phone',telephone.value)

    axios({
      method: "post",
      url: process.env.REACT_APP_BACKEND_REGISTER,
      data: data,
      headers: {
        "Content-type":"multipart/form-data"
      }
    })
    .then(res => {
      if (res.data.hasErrors){
        for (const [key, value] of Object.entries(res.data.errors)) {
          toast.error(value['0'],{
            position: "top-right",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: false,
            draggable: true,
            progress: undefined,
            theme: "colored",
            containerId:"dialog-register"
          })
        }
        setResponse('reg error')
        //console.log('reg error:',res)
      }else{
        let timestamp = Date.now()
        localStorage.setItem('token', res.data.token)
        localStorage.setItem('username', username.value)
        localStorage.setItem('timestamp', timestamp)
        setAuth({ token:res.data.token,
                  username: username.value,
                  timestamp: timestamp,
                  isAuth:true})
        setResponse('registred')
        handleClose()
      }
    })
    .catch((err) =>{
      console.log("reg error",err)
    })
  }

  function handleDialogAction(){
    setRegistred(!registred)
  }

  function handleClose(e = undefined){
    if (e !== undefined && e.key !== "Escape") return null
    //console.log("closing because: ",e)
    dialogRef.current.setAttribute("open", false)
    dialogRef.current.close()
    setDialogState(false)
    closeDialog('')
  }

  function handleOpenDialog(){
    setDialogState(true)
    dialogRef.current.removeAttribute("open");
    dialogRef.current.showModal();
  }

  // toast management
  useEffect(()=> {
    switch (response) {
      case 'registred':
        toast.success(lang['toast registred'],{
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: false,
          draggable: true,
          progress: undefined,
          theme: "colored",
          containerId:"app"
        })
        break
      case 'reg error':
        toast.warn(lang['toast not registred'],{
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: false,
          draggable: true,
          progress: undefined,
          theme: "colored",
          containerId:"dialog-register"
        })
        break
      case 'logged in':
        toast.success((lang['toast logged in'] + auth.username),{
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: false,
          draggable: true,
          progress: undefined,
          theme: "colored",
          containerId:"app"
        })
        break
      case 'log in error':
        toast.warn(lang['toast not logged in'],{
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: false,
          draggable: true,
          progress: undefined,
          theme: "colored",
          containerId:"dialog-register"
        })
        break
      default:
        break
    }
    setResponse('')
  },[response])

  return <dialog
            className={"dialog-register"+ (!dialogState ? ' hidden' : '') + (registred ? ' login' : '')} 
            open={dialogState} ref={dialogRef} 
            onKeyDown={e => handleClose(e)}>
    <h1>{lang["dialog register title"]}</h1>

    <label className="required" htmlFor="dialog-username">
      <span>{lang["dialog username"]}</span>
      <input 
          type="text" 
          name="username" 
          id="dialog-username" 
          required 
          pattern={pattern.username}
          ref={usernameRef} />
    </label>

    <label className="required regonly" htmlFor="dialog-mail">
      <span>{lang["dialog mail"]}</span>
      <input 
          type="email" 
          name="mail" 
          id="dialog-mail" 
          required 
          pattern={pattern.mail} 
          ref={emailRef}
          />
    </label>

    <label className="required regonly" htmlFor="dialog-firstname">
      <span>{lang["dialog firstname"]}</span>
      <input 
          type="text" 
          name="firstname" 
          id="dialog-firstname" 
          required 
          pattern={pattern.firstname} 
          ref={firstNameRef}
          />
    </label>

    <label className="required regonly" htmlFor="dialog-secondname">
      <span>{lang["dialog secondname"]}</span>
      <input 
          type="text" 
          name="secondname" 
          id="dialog-name" 
          required 
          pattern={pattern.name} 
          ref={secondNameRef}
          />
    </label>

    <label className="required regonly" htmlFor="dialog-lastname">
      <span>{lang["dialog lastname"]}</span>
      <input 
          type="text" 
          name="lastname" 
          id="dialog-lastname" 
          required 
          pattern={pattern.lastname} 
          ref={lastNameRef}
          />
    </label>

    <label className="required regonly" htmlFor="dialog-telephone">
      <span>{lang["dialog telephone"]}</span>
      <input 
          type="telephone" 
          name="telephone" 
          id="dialog-telephone" 
          required 
          pattern={pattern.telephone} 
          ref={telephoneRef}
          />
    </label>

    <label className="required regonly" htmlFor="dialog-date-of-birth">
      <span>{lang["dialog date of birth"]}</span>
      <input 
          type="date" 
          name="birthDate" 
          id="dialog-date-of-birth" 
          required 
          pattern={pattern.birthDate} 
          ref={birthdateRef}
          />
    </label>

    <label className="required regonly" htmlFor="dialog-country">
      <span>{lang["dialog country"]}</span>
      <input 
          type="text" 
          name="country" 
          id="dialog-country" 
          pattern={pattern.country} 
          required
          ref={countryRef}
          />
    </label>

    <label className="required regonly" htmlFor="dialog-city">
      <span>{lang["dialog city"]}</span>
      <input 
          type="text" 
          name="city" 
          id="dialog-city" 
          required 
          pattern={pattern.city}
          ref={cityRef}
          />
    </label>

    <fieldset className="dialog-fieldset regonly">

      <legend>{lang["dialog np title"]}</legend>
      <label htmlFor="dialog-np-region">
        <span>{lang["dialog np region"]}</span>
        <select name="npArea" id="dialog-np-region" onChange={(e) => updateCities(e)} ref={npAreaRef}>
          <option value="none" disabled defaultValue>--- --- ---</option>
          {Object.entries(areas).map( ([key, value]) => {
            return <option value={key} key={key}>{value}</option>
          })}

        </select>
      </label>

      <label htmlFor="dialog-np-city">
        <span>{lang["dialog np city"]}</span>
        <select name="npCity" id="dialog-np-city" onChange={(e) => updateWahehouses(e)} ref={npCityRef}>
          <option value="none" disabled defaultValue default>--- --- ---</option>
          {Object.entries(cities).map( ([key, value]) => {
            return <option value={key} key={key}>{value.substring(0,50)}</option>
          })}
        </select>
      </label>

      <label htmlFor="dialog-np-warehouse">
        <span>{lang["dialog np wharehouse"]}NP </span>
        <select name="npWarehouse" id="dialog-np-warehouse" ref={npWhRef}>
          <option value="none" selected default>--- --- ---</option>
          {Object.entries(wh).map( ([key, value]) => {
            return <option value={key} key={key}>{value}</option>
          })}
        </select>
      </label>

    </fieldset>

    <label className="required regonly" htmlFor="dialog-sex">
      <span>{lang["dialog sex"]}</span>
      <select name="sex" id="dialog-sex" ref={genderRef}>
        <option value="0">M</option>
        <option value="1">F</option>
        <option value="-1" defaultValue>x</option>
      </select>
    </label>

    <label className="regonly" htmlFor="dialog-shirt-size">
      <span>{lang["dialog shirt size"]}</span>
      <select name="size" id="dialog-shirt-size" ref={shirtRef}>
        <option value="xs">XS</option>
        <option value="s">S</option>
        <option value="m">M</option>
        <option value="l">L</option>
        <option value="xl">XL</option>
        <option value="xxl">XXL</option>
      </select>
    </label>

    <label className="regonly" htmlFor="dialog-running-club">
      <span>{lang["dialog running club"]}</span>
      <input 
          type="text" 
          name="club" 
          id="dialog-running-club"  
          pattern={pattern.club}
          ref={clubRef}
          />
    </label>

    <label className="required regonly" htmlFor="dialog-emergency-contacts">
      <span>{lang["dialog emergency contacts"]}</span>
      <input 
          type="text" 
          name="emergencyContacts" 
          id="dialog-emergency-contacts" 
          required 
          pattern={pattern.emergencyContacts}
          ref={sosRef}
          />
    </label>

    <label className="required" htmlFor="dialog-password">
      <span>{lang["dialog password"]}</span>
      <input 
          type="password" 
          name="password" 
          id="dialog-password" 
          required 
          pattern={pattern.password}
          ref={passwordRef} />
    </label>

    <label className="required regonly" htmlFor="dialog-repeat-password">
      <span>{lang["dialog repeat password"]}</span>
      <input 
          type="password" 
          name="repeatPassword" 
          id="dialog-repeat-password" 
          required 
          pattern={pattern.repeatPassword}
          ref={passwordRepeatRef}
          />
    </label>

    <label className="regonly" htmlFor="dialog-avatar">
      <span>{lang["dialog avatar"]}</span>
      <input 
          type="file" 
          name="avatar" 
          id="dialog-avatar"
          accept=".jpg,.png,.jpeg,.gif"
          ref={ava}
          />
    </label>

    <label htmlFor="dialog-accept-policies" className="dialog-policies regonly">
      <input type="checkbox" name="acceptPolicies" id="dialog-accept-policies" ref={policiesRef}/>
      <span>{lang["dialog accept policies"]} <a href={lang["dialog policies link"]}></a></span>
    </label>

    <div className="dialog-buttons">
      <button className="button-teal" onClick={() => handleClose()} value="cancel">{lang["dialog cancel"]}</button>
      <button className="button-red" onClick={() => handleSubmit()}>{!registred ? lang["dialog register"] : lang["dialog login"]}</button>
      
    </div>

    <label htmlFor="dialog-switch" className="dialog-switcher">
      <span className="dialog-switcher__title">{lang["dialog switch title"]}</span>
      <input type="checkbox" checked={registred} id="dialog-switch" onChange={() => handleDialogAction()}/>
      <span className='login'>{lang["dialog switch log in"]}</span>
      <span className='signin'>{lang["dialog switch sign in"]}</span>
      <span className="marker"></span>
    </label>

    <ToastContainer enableMultiContainer containerId={'dialog-register'}/>

  </dialog>
  
})

export default Register